import { formatExperimentsForEventAttributes } from '@reverbdotcom/commons/src/elog/mparticle';
import { MParticleEventName } from '@reverbdotcom/commons/src/elog/mparticle_types';
import { useViewTracking } from '@reverbdotcom/commons/src/use_tracking';
import { experimentInt } from '@reverbdotcom/commons/src/user_context_helpers';
import { useUser } from '@reverbdotcom/commons/src/user_hooks';
import React, { FC } from 'react';
import { ExperimentGroupValue } from './experiment_group';

interface ExperimentWrapperProps {
  componentName: string;
  experiment: string;
}

interface ExperimentContextProps {
  expDesc?: string;
  expGroup?: ExperimentGroupValue;
}

export const ExperimentContext = React.createContext({} as ExperimentContextProps);

const ExperimentBlock: FC<ExperimentWrapperProps> = (props) => {
  const user = useUser();
  const expGroup = experimentInt(user, props.experiment) as ExperimentGroupValue;
  const expDesc = formatExperimentsForEventAttributes(user, [props.experiment]);

  useViewTracking({
    eventName: MParticleEventName.ComponentView,
    componentName: props.componentName,
    experiments: expDesc,
  }, expGroup >= 0);

  return (
    <ExperimentContext.Provider value={ { expDesc, expGroup } }>
      {props.children}
    </ExperimentContext.Provider>
  );
};

export default ExperimentBlock;
